import { AssertionError } from '../errors';

export function assert<TCondition>(condition: TCondition, message?: string): asserts condition {
  if (!condition) {
    throw new AssertionError(message);
  }
}
